
import { Options, Vue } from 'vue-class-component';
import { CourseProduct, Product } from "@/data/products";
import { formatPrice } from "@/utils/helpers";
import ProductCard from "@/components/ProductCard.vue";
import ProductOrderPaymentModal from "@/components/modals/ProductOrderPaymentModal.vue";

@Options({
    props: {
        product: {
            type: Object,
            required: true,
        },
        regionName: {
            type: String,
            required: false,
        },
        classes: {
            type: Object,
            required: false,
            default: {},
        },
    },
    methods: {
        formatPrice,
    },
    components: {
        ProductCard,
        ProductOrderPaymentModal,
    },
})
export default class ProductCardOrderable extends Vue {
    product!: Product|CourseProduct
    regionName!: string|null
    classes!: Record<string, boolean>

    modalShown = false

    /*mounted() {

    }*/
}
